import React, { Fragment } from 'react';
import { Stack, Grid, Box, Popover, Typography, InputAdornment, IconButton } from '@mui/material';
import { StyledDataGrid, StyledCard, StyledCardTitle, DataGridProps, PopoverContent, CustomTextField, InputProps, FlexDiv, CustomSearch } from '../../../../../../../custom/components';
import dollyTareStyle from './dollytare.module.css';
import styles from '../../../../../../../custom/style.module.css';
import { AddIcon, DateFormat, DeleteIcon, EditIcon, } from '../../../../../../../custom/constants';
import { dateTolocale } from 'utils/converter';
import { Add, Close, EmailOutlined, Search, Warning } from '@mui/icons-material';
import dayjs from 'dayjs';

const DollyTare = (props) => {

  const dollyTareRows = props.dolly_mail.map((item, index) => ({
    id: index,
    email: item,
  }));

  const dollyTareColumn = [
    {
      field: 'prefix',
      headerName: 'Prefix',
      flex: 1,
    },
    {
      field: 'number',
      headerName: 'Number',
      flex: 1,
    },
    {
      field: 'wgt',
      headerName: 'Weight',
      flex: 1,
    },
    {
      field: 'expiry',
      headerName: 'Expiry',
      flex: 1,
      headerClassName: styles.pl4,
      renderCell: ({ row }) => {
        const today = dayjs();
        const eventDate = dayjs(dateTolocale(row.expiry, DateFormat));
        const daysUntilEvent = eventDate.diff(today, 'day');
        const showIcon = daysUntilEvent >= 0 && daysUntilEvent <= 15;

        return (
          <Stack direction={'row'} spacing={1} alignItems='center'>
            <Warning color='warning' sx={{
              ml: 1,
              fontSize: 16,
              visibility: showIcon ? 'visible' : 'hidden',
            }} />
            <Typography variant='inherit'>{dateTolocale(row.expiry, DateFormat).toUpperCase()}</Typography>
            {showIcon &&
              <Typography variant='caption' color='text.secondary' fontStyle='italic' fontWeight={600} ml={0.2}>
                ({daysUntilEvent} Days until expiry)
              </Typography>
            }
          </Stack>);
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      headerAlign: 'center',
      align: 'center',
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='center' className={styles.actionIcons}>
            <EditIcon onClick={() => props.handleOpen('dolly_tare', 'edit', row)} />
            <DeleteIcon onClick={(e) => props.handleDelete(row.id, e.target)} />
          </Stack>
        );
      }
    },
  ];

  const masterEmailColumn = [
    {
      field: 'email',
      headerName: 'Master Email',
      flex: 1,
      renderCell: ({ row }) => {
        return row.email;
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      headerAlign: 'center',
      align: 'center',
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='center' className={styles.actionIcons}>
            <DeleteIcon onClick={() => props.onRemoveDollyMail(row.email)} />
          </Stack>
        );
      }
    },
  ];


  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
          <StyledCard>
            <FlexDiv><StyledCardTitle>Dolly Tare</StyledCardTitle></FlexDiv>
            <Stack direction='row' spacing={2} alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-24px'}>
              <CustomSearch
                id='search'
                variant='outlined'
                size='small'
                type='search'
                placeholder='Enter Number'
                name='no'
                className={`${styles.brInput} ${styles.width245}`}
                value={props?.filterData?.no}
                onChange={props.handleFilterChange}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      onClick={props.filter}
                    >
                      <Search fontSize='inherit' />
                    </IconButton>
                  </InputAdornment>,
                }}
                onKeyDown={
                  (e) => {
                    if (e.key === 'Enter') {
                      props.filter(true);
                    }
                  }
                }
              />
              <AddIcon className={styles.addIcon} title='Add Dolly Tare' onClick={() => props.handleOpen('dolly_tare', 'add')} />
            </Stack>
            <div className={styles.tableWrapper}>
              <Box className={`${styles.tableOuter} ${dollyTareStyle.dollyTareTableOuter}`}>
                <StyledDataGrid
                  {...DataGridProps}
                  rows={props.dollys}
                  columns={dollyTareColumn}
                  param={props.dollys?.length}
                />
              </Box>
            </div>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={10} lg={4} xl={4}>
          <StyledCard className={`${styles.h100}`}>
            <FlexDiv><StyledCardTitle>Master Email List (for expiry notification)</StyledCardTitle></FlexDiv>
            <Fragment>
              <Grid container spacing={3} alignItems='flex-start' mb={2}>
                <Grid item xs>
                  <CustomTextField
                    {...InputProps}
                    id=''
                    placeholder='Enter Master Email'
                    name='mail'
                    fullWidth
                    value={props.dolly_mailFields.mail || ''}
                    onChange={props.onChangeDollyMail}
                    error={props.dolly_mailErrors.mail}
                    helperText={props.dolly_mailErrors.mail}
                  />
                </Grid>
                <Grid item xs={'auto'} display={'flex'}>
                  <AddIcon className={styles.addIcon} title='Add Master Email' onClick={props.onAddDollyMail} />
                </Grid>
              </Grid>
              <div className={styles.tableWrapper}>
                <Box mt={1} className={`${styles.tableOuter} ${dollyTareStyle.masterEmailTableOuter}`}>
                  <StyledDataGrid
                    {...DataGridProps}
                    rows={dollyTareRows}
                    columns={masterEmailColumn}
                    param={dollyTareRows?.length}
                  />
                </Box>
              </div>
            </Fragment>
          </StyledCard>
        </Grid>
      </Grid>

      <Popover
        open={props.modal === 'master_email'}
        anchorEl={props.action}
        onClose={props.onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        slotProps={{ paper: { className: dollyTareStyle.emailPopover, } }}>

        <PopoverContent className={dollyTareStyle.popoverContent}>
          <Stack direction='column'>
            <Typography variant='caption' color='text.secondary' fontWeight={600} >Add Master Email</Typography>
            <CustomTextField
              variant='standard'
              id=''
              size='small'
              placeholder='Enter Email'
              className={dollyTareStyle.mailTextfield}
              name='mail'
              value={props.dolly_mailFields.mail || ''}
              onChange={props.onChangeDollyMail}
              error={props.dolly_mailErrors.mail}
              helperText={props.dolly_mailErrors.mail}
              InputProps={{
                classes: {
                  root: dollyTareStyle.mailRootTextfield,
                  input: dollyTareStyle.mailTextfieldInput,
                },
                startAdornment: (
                  <InputAdornment position='start'>
                    <EmailOutlined fontSize='small' color='primary' />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      className={dollyTareStyle.masterEmailAddBtn}
                      onClick={props.onAddDollyMail}
                      disableRipple
                      color='primary'
                    >
                      <Add fontSize='inherit' />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Stack>

          <Stack direction='column' spacing={1} justifyContent='flex-end' mt={2}>
            <Typography variant='caption' color='text.secondary' fontWeight={600} >Emails Added:</Typography>
            <Stack direction='row' columnGap={1} rowGap={2} flexWrap={'wrap'}>
              {props.dolly_mail.map((mail, index) => (
                <div key={index} className={styles.positionRelative}>
                  <Typography variant='body2' color='primary' fontWeight={600} px={2} borderRadius={4} bgcolor={'#e8e8e8'}>{mail}</Typography>
                  <IconButton
                    size='small'
                    className={dollyTareStyle.removeEmail}
                    disableRipple
                    onClick={() => props.onRemoveDollyMail(mail)}
                  >
                    <Close sx={{ fontSize: 12 }} />
                  </IconButton>
                </div>
              ))}
            </Stack>
          </Stack>

        </PopoverContent>
      </Popover>
    </div>
  );
};

export default DollyTare;
